export default "__VITE_ASSET__BlnNyKD7__"